/**
 * Ticket group status options for events
 */
export const TICKET_GROUP_STATUSES = [
  { id: 0, name: 'On Sale' },
  { id: 1, name: 'Sold Out' },
  { id: 2, name: 'Hidden' },
];

/**
 * Dress code options for events
 */
export const DRESS_CODES = [
  { id: 1, name: 'Casual' },
  { id: 2, name: 'Come as you are' },
  { id: 3, name: 'Elegant' },
  { id: 4, name: 'Smart Casual' },
  { id: 5, name: 'No Dress Code' },
];

/**
 * Couples rules options for events
 */
export const COUPLES_RULES = [
  { id: 1, name: 'No Rules' },
  { id: 2, name: 'Men have to be with women' },
];

/**
 * Event type options
 */
export const EVENT_TYPES = [
  { id: 1, name: 'Standard Event' },
  { id: 2, name: 'Area Layout Event' },
  { id: 3, name: 'Seated Event' },
];

/**
 * Date type options
 */
export const DATE_TYPES = [
  { id: 'oneoff', name: 'Single Date / One Off' },
  { id: 'session', name: 'Multiple Dates / Sessions' },
];

/**
 * Event status options
 */
export const EVENT_STATUSES = [
  { id: 'draft', name: 'Draft' },
  { id: 'published', name: 'Published' },
  { id: 'cancelled', name: 'Cancelled' },
  { id: 'completed', name: 'Completed' },
];

/**
 * Commission fee options
 */
export const COMMISSION_FEES = [
  { id: 3, name: '3%' },
  { id: 5, name: '5%' },
  { id: 7, name: '7%' },
  { id: 10, name: '10%' },
];

/**
 * Payment method options
 */
export const PAYMENT_METHODS = [
  { id: 'cc', name: 'Credit Card' },
  { id: 'doorcash', name: 'Cash At Door' },
];

/**
 * Form field configurations
 */
export const FORM_FIELD_CONFIGS = {
  EVENT_TYPES,
  DATE_TYPES,
  TICKET_GROUP_STATUSES,
  DRESS_CODES,
  COUPLES_RULES,
  PAYMENT_METHODS,
  COMMISSION_FEES,
};

/**
 * Validation rules for form fields
 */
export const VALIDATION_RULES = {
  EVENT_NAME: { required: true, maxLength: 100 },
  DESCRIPTION: { required: true, minLength: 10 },
  PRICE: { required: true, min: 0 },
  STOCK: { required: true, min: 0 },
  DURATION: { required: true, min: 1 },
  BADGE_LABEL: { maxLength: 23 },
};

/**
 * Form tab configurations
 */
export const FORM_TAB_CONFIGS = {
  BASIC_DETAILS: {
    label: 'Basic Details',
    required: true,
    order: 1,
  },
  DATE_DETAILS: {
    label: 'Date Details',
    required: true,
    order: 2,
  },
  MORE_DETAILS: {
    label: 'More Details',
    required: false,
    order: 3,
  },
  VISUALS: {
    label: 'Visuals',
    required: false,
    order: 4,
  },
  PRODUCTS: {
    label: 'Products/Tickets',
    required: true,
    order: 5,
  },
  LAYOUT: {
    label: 'Layout',
    required: false,
    conditional: true,
    order: 6,
  },
  COUPONS: {
    label: 'Coupons',
    required: false,
    order: 7,
  },
  FEES: {
    label: 'Fees',
    required: false,
    order: 8,
  },
  SETTINGS: {
    label: 'Settings',
    required: false,
    order: 9,
  },
};

/**
 * Default form values
 */
export const DEFAULT_FORM_VALUES = {
  paymentMethods: ['cc'],
  isActive: false,
  isVerified: false,
  isCommissionExtra: false,
  hasDownPayment: false,
  hasBasketLimit: false,
  isPromotionAvailable: false,
  status: 0, // On Sale
  dress: [],
  couples: [],
};

/**
 * Helper functions for form configuration
 */
export const getEventTypeName = (eventTypeId) => {
  const eventType = EVENT_TYPES.find((type) => type.id === eventTypeId);
  return eventType ? eventType.name : 'Unknown';
};

export const getDateTypeName = (dateTypeId) => {
  const dateType = DATE_TYPES.find((type) => type.id === dateTypeId);
  return dateType ? dateType.name : 'Unknown';
};

export const isLayoutRequired = (eventType) => {
  return eventType === 2 || eventType === 3; // Area Layout or Seated Event
};

export const getLayoutType = (eventType) => {
  return eventType === 2 ? 'area' : eventType === 3 ? 'seating' : null;
};
